import type { Area } from 'react-easy-crop';

const AVATAR_SIZE = 512;
const JPEG_QUALITY = 0.9;

export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('IMAGE_DECODE_FAILED'));
    img.src = src;
  });
}

/** Crops `area` (in source pixels) out of `src` into a `width`×`height` JPEG. */
export async function cropToJpeg(src: string, area: Area, width: number, height: number): Promise<Blob> {
  const img = await loadImage(src);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('CANVAS_UNAVAILABLE');
  ctx.drawImage(img, area.x, area.y, area.width, area.height, 0, 0, width, height);

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => (blob ? resolve(blob) : reject(new Error('CANVAS_EXPORT_FAILED'))),
      'image/jpeg',
      JPEG_QUALITY,
    );
  });
}

export function cropToSquareJpeg(src: string, area: Area): Promise<Blob> {
  return cropToJpeg(src, area, AVATAR_SIZE, AVATAR_SIZE);
}
